import React from 'react';
import { Link, Navigate } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { useTranslation, Trans } from 'react-i18next';

const Landing = ({ isAuthenticated }) => {
  const { t } = useTranslation();

  if (isAuthenticated) {
    return <Navigate to="/dashboard" />;
  }

  return (
    <section className="landing">
      <div className="dark-overlay">
        <Trans>
          <div className="landing-inner">
            <h1 className="x-large">{t('landing_title')}</h1>
            <p className="lead">{t('landing_lead')}</p>
            <div className="buttons">
              <Link to="/login" className="btn btn-light">
                Login
              </Link>
            </div>
          </div>
        </Trans>
      </div>
    </section>
  );
};

Landing.propTypes = {
  isAuthenticated: PropTypes.bool
};

const mapStateToProps = (state) => ({
  isAuthenticated: state.auth.isAuthenticated
});

export default connect(mapStateToProps)(Landing);
